import { styles } from "@repo/helpers";

import style from "./style.module.scss";

export interface SkeletonProps {
	className?: string;
	width?: string | number;
	height?: string | number;
}

export function Skeleton({ className, width, height }: SkeletonProps) {
	return (
		<div
			className={styles(style.skeleton, className)}
			style={{
				width,
				height,
			}}
		/>
	);
}
